import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './DetailsTaskButtons.css';
import Button from 'components/shared/button/Button';
import numeral from 'numeral';

export default class DetailsTaskButtons extends Component {
  static propTypes = {
    requestBids: PropTypes.bool,
    editTask: PropTypes.bool,
    deleteTask: PropTypes.bool,
    createQuote: PropTypes.bool,
    askQuestion: PropTypes.bool,
    noThanks: PropTypes.bool,
    withdrawQuote: PropTypes.bool,
    viewCounterQuote: PropTypes.bool,
    resubmitQuote: PropTypes.bool,
    startTask: PropTypes.shape({
      enable: PropTypes.bool,
      show: PropTypes.bool,
    }),
    markAsCompleted: PropTypes.shape({
      enable: PropTypes.bool,
      show: PropTypes.bool,
    }),
    approveWork: PropTypes.bool,
    showCompleted: PropTypes.bool,
    task: PropTypes.shape({
      number: PropTypes.number.isRequired,
      name: PropTypes.string,
    }).isRequired,
    workOrder: PropTypes.shape({
      name: PropTypes.string,
      number: PropTypes.number.isRequired,
    }).isRequired,
    onRequestBids: PropTypes.func,
    onTaskEdit: PropTypes.func,
    onTaskDelete: PropTypes.func,
    onCreateQuote: PropTypes.func,
    onDenyQuote: PropTypes.func,
    onWithdrawQuote: PropTypes.func,
    onViewCounterQuote: PropTypes.func,
    onResubmitQuote: PropTypes.func,
    onStartTask: PropTypes.func,
    onMarkAsComplete: PropTypes.func,
    onApproveWork: PropTypes.func,
  };

  static defaultProps = {
    addTime: false,
    requestBids: false,
    editTask: false,
    deleteTask: false,
    createQuote: false,
    askQuestion: false,
    noThanks: false,
    withdrawQuote: false,
    startTask: {
      enable: false,
      show: false,
    },
    markAsCompleted: {
      enable: false,
      show: false,
    },
    approveWork: false,
    showCompleted: false,
  };

  render() {
    return (
      <div className="details-task-button-container">
        {this.props.requestBids && (
          <Button
            id="request-bids-button"
            className="button-orange"
            label="Request Bids"
            onClick={this.handleBidsRequest}
          />
        )}
        {this.props.editTask && (
          <Button
            id="edit-task-button"
            className="button-gray"
            label="Edit Task"
            onClick={this.handleTaskEdit}
          />
        )}
        {this.props.deleteTask && (
          <Button
            id="delete-task-button"
            className="button-white"
            label="Delete Task"
            onClick={this.handleDeleteTask}
          />
        )}
        {this.props.createQuote && (
          <Button
            id="create-quote-button"
            className="button-orange"
            label="Create Quote"
            onClick={this.handleCreateQuote}
          />
        )}
        {this.props.askQuestion && this.renderAskQuestionButton()}
        {this.props.noThanks && (
          <Button
            id="no-thanks-button"
            className="button-white"
            label="No, Thanks"
            onClick={this.handleDenyQuote}
          />
        )}
        {this.props.withdrawQuote && (
          <Button
            id="withdraw-quote-button"
            className="button-orange withdraw"
            label="Withdraw Quote"
            onClick={this.handleWithdrawQuote}
          />
        )}
        {this.props.viewCounterQuote && (
          <Button
            id="view-counter-quote-button"
            className="button-gray"
            label="View Counter"
            onClick={this.handleViewCounterQuote}
          />
        )}
        {this.props.resubmitQuote && (
          <Button
            id="resubmit-quote-button"
            className="button-orange withdraw"
            label="Resubmit Quote"
            onClick={this.handleResubmitQuote}
          />
        )}
        {this.props.startTask.show && (
          <Button
            id="start-task-button"
            className="button-white-orange"
            disabled={!this.props.startTask.enable}
            label="Start Task"
            onClick={this.handleStartTask}
          />
        )}
        {this.props.markAsCompleted.show && (
          <Button
            id="mark-as-complete-button"
            className="button-orange wip"
            disabled={!this.props.markAsCompleted.enable}
            label="Mark as Complete"
            onClick={this.handleMarkAsCompleteTask}
          />
        )}
        {this.props.approveWork && (
          <Button
            id="approve-work-button"
            className="button-orange"
            label="Approve Work"
            onClick={this.handleApproveWork}
          />
        )}
        {this.props.showCompleted && (
          <div
            id="show-completed-button"
            className="btn button button-blue cmp"
          >
            Completed
          </div>
        )}
      </div>
    );
  }

  static getWorkOrderName(workOrder) {
    return workOrder.name !== undefined && workOrder.name !== null
      ? `:${workOrder.name}`
      : '';
  }

  renderAskQuestionButton() {
    const mailSubject =
      'mailto:admin@spackle.co?subject=' +
      `WO #${this.props.workOrder.number}${DetailsTaskButtons.getWorkOrderName(
        this.props.workOrder
      )}-` +
      `${numeral(this.props.task.number).format('00')}: ` +
      `${this.props.task.name}`;

    return (
      <a
        id="ask-question-button"
        className="btn button button-gray mail-link"
        href={mailSubject}
      >
        Ask a question
      </a>
    );
  }

  handleBidsRequest = () => {
    if (this.props.onRequestBids) {
      this.props.onRequestBids();
    }
  };

  handleTaskEdit = () => {
    if (this.props.onTaskEdit) {
      this.props.onTaskEdit();
    }
  };

  handleDeleteTask = () => {
    if (this.props.onTaskDelete) {
      this.props.onTaskDelete();
    }
  };

  handleCreateQuote = () => {
    if (this.props.onCreateQuote) {
      this.props.onCreateQuote();
    }
  };

  handleDenyQuote = () => {
    if (this.props.onDenyQuote) {
      this.props.onDenyQuote();
    }
  };

  handleWithdrawQuote = () => {
    if (this.props.onWithdrawQuote) {
      this.props.onWithdrawQuote();
    }
  };

  handleViewCounterQuote = () => {
    if (this.props.onViewCounterQuote) {
      this.props.onViewCounterQuote();
    }
  };

  handleResubmitQuote = () => {
    if (this.props.onResubmitQuote) {
      this.props.onResubmitQuote();
    }
  };

  handleStartTask = () => {
    if (this.props.onStartTask) {
      this.props.onStartTask();
    }
  };

  handleMarkAsCompleteTask = () => {
    if (this.props.onMarkAsComplete) {
      this.props.onMarkAsComplete();
    }
  };

  handleApproveWork = () => {
    if (this.props.onApproveWork) {
      this.props.onApproveWork();
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/tasks/DetailsTaskButtons.js